"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _lodash2 = _interopRequireDefault(require("lodash.memoize"));

var _lodash3 = _interopRequireDefault(require("lodash.reduce"));

var _lodash4 = _interopRequireDefault(require("lodash.startswith"));

var _classnames = _interopRequireDefault(require("classnames"));

var _country_data = _interopRequireDefault(require("./country_data.js"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PhoneInput = /*#__PURE__*/function (_React$Component) {
  _inherits(PhoneInput, _React$Component);

  var _super = _createSuper(PhoneInput);

  function PhoneInput(props) {
    var _this;

    _classCallCheck(this, PhoneInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "deleteAreaCodes", function (filteredCountries) {
      return filteredCountries.filter(function (country) {
        return country.isAreaCode !== true;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterRegions", function (regions, filteredCountries) {
      if (typeof regions === 'string') {
        var region = regions;
        return filteredCountries.filter(function (country) {
          return country.regions.some(function (element) {
            return element === region;
          });
        });
      }

      return filteredCountries.filter(function (country) {
        var matches = regions.map(function (region) {
          return country.regions.some(function (element) {
            return element === region;
          });
        });
        return matches.some(function (el) {
          return el;
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFilteredCountryList", function (countryCodes, sourceCountryList, preserveOrder) {
      if (countryCodes.length === 0) return _this.extendCountries(sourceCountryList);
      var filteredCountries;

      if (preserveOrder) {
        // filter with user-defined order
        filteredCountries = countryCodes.map(function (countryCode) {
          var country = sourceCountryList.find(function (country) {
            return country.iso2 === countryCode;
          });
          if (country) return country;
        }).filter(function (country) {
          return country;
        }); // remove any not found
      } else {
        // filter with alphabetical order
        filteredCountries = sourceCountryList.filter(function (country) {
          return countryCodes.some(function (element) {
            return element === country.iso2;
          });
        });
      }

      return _this.extendCountries(filteredCountries);
    });

    _defineProperty(_assertThisInitialized(_this), "extendCountries", function (countries) {
      var _this$props = _this.props,
          localization = _this$props.localization,
          masks = _this$props.masks,
          areaCodes = _this$props.areaCodes;

      for (var i = 0; i < countries.length; i++) {
        if (localization[countries[i].iso2] !== undefined) {
          countries[i].localName = localization[countries[i].iso2];
        } else if (localization[countries[i].name] !== undefined) {
          countries[i].localName = localization[countries[i].name];
        }

        if (masks[countries[i].iso2] !== undefined) {
          countries[i].format = masks[countries[i].iso2];
        } else if (masks[countries[i].name] !== undefined) {
          countries[i].format = masks[countries[i].name];
        }
      }

      if (Object.keys(areaCodes).length > 0) {
        var _ret = function () {
          var updCountries = [];
          var foundCountry = null;

          for (var _i = 0; _i < countries.length; _i++) {
            updCountries.push(countries[_i]);

            if (areaCodes[countries[_i].iso2] !== undefined) {
              if (!foundCountry) foundCountry = countries[_i];
              if (countries[_i + 1] && countries[_i + 1].iso2 === foundCountry.iso2) continue;

              _this.getCustomAreas(foundCountry, areaCodes[countries[_i].iso2]).forEach(function (o) {
                updCountries.push(o);
              });

              foundCountry = null;
            } else if (areaCodes[countries[_i].name] !== undefined) {
              if (!foundCountry) foundCountry = countries[_i]; // skip until all native area codes pushed

              if (countries[_i + 1] && countries[_i + 1].iso2 === foundCountry.iso2) continue;

              _this.getCustomAreas(foundCountry, areaCodes[countries[_i].name]).forEach(function (o) {
                updCountries.push(o);
              });

              foundCountry = null;
            }
          }

          return {
            v: updCountries
          };
        }();

        if (_typeof(_ret) === "object") return _ret.v;
      }

      return countries;
    });

    _defineProperty(_assertThisInitialized(_this), "getCustomAreas", function (country, areaCodes) {
      var customAreas = [];

      for (var i = 0; i < areaCodes.length; i++) {
        var newCountry = JSON.parse(JSON.stringify(country));
        newCountry.dialCode += areaCodes[i];
        customAreas.push(newCountry);
      }

      return customAreas;
    });

    _defineProperty(_assertThisInitialized(_this), "excludeCountries", function (selectedCountries, excludedCountries) {
      if (excludedCountries.length === 0) {
        return selectedCountries;
      } else {
        return selectedCountries.filter(function (selCountry) {
          return !excludedCountries.includes(selCountry.iso2);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getProbableCandidate", (0, _lodash2["default"])(function (queryString) {
      if (!queryString || queryString.length === 0) {
        return null;
      } // don't include the preferred countries in search


      var probableCountries = _this.state.onlyCountries.filter(function (country) {
        return (0, _lodash4["default"])(country.name.toLowerCase(), queryString.toLowerCase());
      }, _assertThisInitialized(_this));

      return probableCountries[0];
    }));

    _defineProperty(_assertThisInitialized(_this), "guessSelectedCountry", (0, _lodash2["default"])(function (inputNumber, onlyCountries, defaultCountry) {
      var secondBestGuess = onlyCountries.find(function (o) {
        return o.iso2 == defaultCountry;
      }) || {};
      if (inputNumber.trim() === '') return secondBestGuess;
      var bestGuess = onlyCountries.reduce(function (selectedCountry, country) {
        if ((0, _lodash4["default"])(inputNumber, country.dialCode)) {
          if (country.dialCode.length > selectedCountry.dialCode.length) {
            return country;
          }

          if (country.dialCode.length === selectedCountry.dialCode.length && country.priority < selectedCountry.priority) {
            return country;
          }
        }

        return selectedCountry;
      }, {
        dialCode: '',
        priority: 10001
      }, _assertThisInitialized(_this));
      if (!bestGuess.name) return secondBestGuess;
      return bestGuess;
    }));

    _defineProperty(_assertThisInitialized(_this), "updateDefaultCountry", function (country) {
      var newSelectedCountry = _this.state.onlyCountries.find(function (o) {
        return o.iso2 == country;
      });

      _this.setState({
        defaultCountry: country,
        selectedCountry: newSelectedCountry,
        formattedNumber: _this.props.disableCountryCode ? '' : '+' + newSelectedCountry.dialCode
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (country, middle) {
      if (!country) return;
      var container = _this.dropdownRef;
      if (!container || !document.body) return;
      var containerHeight = container.offsetHeight;
      var containerOffset = container.getBoundingClientRect();
      var containerTop = containerOffset.top + document.body.scrollTop;
      var containerBottom = containerTop + containerHeight;
      var element = country;
      var elementOffset = element.getBoundingClientRect();
      var elementHeight = element.offsetHeight;
      var elementTop = elementOffset.top + document.body.scrollTop;
      var elementBottom = elementTop + elementHeight;
      var newScrollTop = elementTop - containerTop + container.scrollTop;
      var middleOffset = containerHeight / 2 - elementHeight / 2;

      if (_this.props.enableSearchField ? elementTop < containerTop + 32 : elementTop < containerTop) {
        // scroll up
        if (middle) {
          newScrollTop -= middleOffset;
        }

        container.scrollTop = newScrollTop;
      } else if (elementBottom > containerBottom) {
        // scroll down
        if (middle) {
          newScrollTop += middleOffset;
        }

        var heightDifference = containerHeight - elementHeight;
        container.scrollTop = newScrollTop - heightDifference;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatNumber", function (text, patternArg) {
      var _this$props2 = _this.props,
          disableCountryCode = _this$props2.disableCountryCode,
          enableLongNumbers = _this$props2.enableLongNumbers,
          autoFormat = _this$props2.autoFormat;
      var pattern;

      if (disableCountryCode && patternArg) {
        pattern = patternArg.split(' ');
        pattern.shift();
        pattern = pattern.join(' ');
      } else {
        pattern = patternArg;
      }

      if (!text || text.length === 0) {
        return disableCountryCode ? '' : '+';
      } // for all strings with length less than 3, just return it (1, 2 etc.)
      // also return the same text if the selected country has no fixed format


      if (text && text.length < 2 || !pattern || !autoFormat) {
        return disableCountryCode ? text : "+".concat(text);
      }

      var formattedObject = (0, _lodash3["default"])(pattern, function (acc, character) {
        if (acc.remainingText.length === 0) {
          return acc;
        }

        if (character !== '.') {
          return {
            formattedText: acc.formattedText + character,
            remainingText: acc.remainingText
          };
        }

        var _acc$remainingText = _toArray(acc.remainingText),
            head = _acc$remainingText[0],
            tail = _acc$remainingText.slice(1);

        return {
          formattedText: acc.formattedText + head,
          remainingText: tail
        };
      }, {
        formattedText: '',
        remainingText: text.split('')
      });
      var formattedNumber;

      if (enableLongNumbers) {
        formattedNumber = formattedObject.formattedText + formattedObject.remainingText.join('');
      } else {
        formattedNumber = formattedObject.formattedText;
      } // Always close brackets


      if (formattedNumber.includes('(') && !formattedNumber.includes(')')) formattedNumber += ')';
      return formattedNumber;
    });

    _defineProperty(_assertThisInitialized(_this), "cursorToEnd", function () {
      var input = _this.numberInputRef;
      input.focus();
      var len = input.value.length;
      input.setSelectionRange(len, len);
    });

    _defineProperty(_assertThisInitialized(_this), "getElement", function (index) {
      return _this["flag_no_".concat(index)];
    });

    _defineProperty(_assertThisInitialized(_this), "getCountryData", function () {
      if (!_this.state.selectedCountry) return {};
      return {
        name: _this.state.selectedCountry.name || '',
        dialCode: _this.state.selectedCountry.dialCode || '',
        countryCode: _this.state.selectedCountry.iso2 || ''
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleFlagDropdownClick", function () {
      if (!_this.state.showDropdown && _this.props.disabled) return;

      if (_this.state.preferredCountries.includes(_this.state.selectedCountry)) {
        _this.setState({
          showDropdown: !_this.state.showDropdown,
          highlightCountryIndex: _this.state.preferredCountries.findIndex(function (o) {
            return o == _this.state.selectedCountry;
          })
        }, function () {
          if (_this.state.showDropdown) {
            _this.scrollTo(_this.getElement(_this.state.highlightCountryIndex));
          }
        });
      } else {
        var onlyCountries = _this.props.disableAreaCodes ? _this.deleteAreaCodes(_this.state.onlyCountries) : _this.state.onlyCountries;

        _this.setState({
          showDropdown: !_this.state.showDropdown,
          highlightCountryIndex: _this.props.disableAreaCodes ? onlyCountries.findIndex(function (o) {
            return o.iso2 == _this.state.selectedCountry.iso2;
          }) : onlyCountries.findIndex(function (o) {
            return o == _this.state.selectedCountry;
          })
        }, function () {
          if (_this.state.showDropdown) {
            _this.scrollTo(_this.getElement(_this.state.highlightCountryIndex + _this.state.preferredCountries.length));
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInput", function (e) {
      var formattedNumber = _this.props.disableCountryCode ? '' : '+';
      var newSelectedCountry = _this.state.selectedCountry;
      var freezeSelection = _this.state.freezeSelection;

      if (!_this.props.countryCodeEditable) {
        var mainCode = newSelectedCountry.hasAreaCodes ? _this.state.onlyCountries.find(function (o) {
          return o.iso2 === newSelectedCountry.iso2 && o.mainCode;
        }).dialCode : newSelectedCountry.dialCode;
        var updatedInput = '+' + mainCode;

        if (e.target.value.length < updatedInput.length) {
          return;
        }
      } // Does not exceed 15 digit phone number limit


      if (e.target.value.replace(/\D/g, '').length > 15) return; // if the input is the same as before, must be some special key like enter etc.

      if (e.target.value === _this.state.formattedNumber) return; // ie hack

      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }

      if (e.target.value.length > 0) {
        // before entering the number in new format, lets check if the dial code now matches some other country
        var inputNumber = e.target.value.replace(/\D/g, ''); // we don't need to send the whole number to guess the country... only the first 6 characters are enough
        // the guess country function can then use memoization much more effectively since the set of input it
        // gets has drastically reduced

        if (!_this.state.freezeSelection || _this.state.selectedCountry.dialCode.length > inputNumber.length) {
          newSelectedCountry = _this.guessSelectedCountry(inputNumber.substring(0, 6), _this.state.onlyCountries, _this.state.defaultCountry);
          freezeSelection = false;
        }

        formattedNumber = _this.formatNumber(inputNumber, newSelectedCountry.format); // remove all non numerals from the input

        newSelectedCountry = newSelectedCountry.dialCode ? newSelectedCountry : _this.state.selectedCountry;
      }

      var caretPosition = e.target.selectionStart;
      var oldFormattedText = _this.state.formattedNumber;
      var diff = formattedNumber.length - oldFormattedText.length;

      _this.setState({
        formattedNumber: formattedNumber,
        freezeSelection: freezeSelection,
        selectedCountry: newSelectedCountry
      }, function () {
        if (diff > 0) {
          caretPosition = caretPosition - diff;
        }

        var lastChar = formattedNumber.charAt(formattedNumber.length - 1);

        if (lastChar == ')') {
          _this.numberInputRef.setSelectionRange(formattedNumber.length - 1, formattedNumber.length - 1);
        } else if (caretPosition > 0 && oldFormattedText.length >= formattedNumber.length) {
          _this.numberInputRef.setSelectionRange(caretPosition, caretPosition);
        }

        if (_this.props.onChange) _this.props.onChange(_this.state.formattedNumber, _this.getCountryData());
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputClick", function (e) {
      _this.setState({
        showDropdown: false
      });

      if (_this.props.onClick) _this.props.onClick(e, _this.getCountryData());
    });

    _defineProperty(_assertThisInitialized(_this), "handleFlagItemClick", function (country) {
      var currentSelectedCountry = _this.state.selectedCountry;

      var nextSelectedCountry = _this.state.onlyCountries.find(function (o) {
        return o == country;
      });

      if (!nextSelectedCountry) return;

      var unformattedNumber = _this.state.formattedNumber.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');

      var newNumber = unformattedNumber.length > 1 ? unformattedNumber.replace(currentSelectedCountry.dialCode, nextSelectedCountry.dialCode) : nextSelectedCountry.dialCode;

      var formattedNumber = _this.formatNumber(newNumber.replace(/\D/g, ''), nextSelectedCountry.format);

      _this.setState({
        showDropdown: false,
        selectedCountry: nextSelectedCountry,
        freezeSelection: true,
        formattedNumber: formattedNumber
      }, function () {
        _this.cursorToEnd();

        if (_this.props.onChange) _this.props.onChange(formattedNumber.replace(/[^0-9]+/g, ''), _this.getCountryData());
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputFocus", function (e) {
      // if the input is blank, insert dial code of the selected country
      if (_this.numberInputRef) {
        if (_this.numberInputRef.value === '+' && _this.state.selectedCountry && !_this.props.disableCountryCode) {
          _this.setState({
            formattedNumber: '+' + _this.state.selectedCountry.dialCode
          }, function () {
            return setTimeout(_this.cursorToEnd, 10);
          });
        }
      }

      _this.setState({
        placeholder: ''
      });

      _this.props.onFocus && _this.props.onFocus(e, _this.getCountryData());
      setTimeout(_this.cursorToEnd, 10);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputBlur", function (e) {
      if (!e.target.value) _this.setState({
        placeholder: _this.props.placeholder
      });
      _this.props.onBlur && _this.props.onBlur(e, _this.getCountryData());
    });

    _defineProperty(_assertThisInitialized(_this), "getHighlightCountryIndex", function (direction) {
      // had to write own function because underscore does not have findIndex. lodash has it
      var highlightCountryIndex = _this.state.highlightCountryIndex + direction;

      if (highlightCountryIndex < 0 || highlightCountryIndex >= _this.state.onlyCountries.length + _this.state.preferredCountries.length) {
        return highlightCountryIndex - direction;
      }

      if (_this.props.enableSearchField && highlightCountryIndex > _this.getSearchFilteredCountries().length) return 0; // select first country

      return highlightCountryIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "searchCountry", function () {
      var probableCandidate = _this.getProbableCandidate(_this.state.queryString) || _this.state.onlyCountries[0];

      var probableCandidateIndex = _this.state.onlyCountries.findIndex(function (o) {
        return o == probableCandidate;
      }) + _this.state.preferredCountries.length;

      _this.scrollTo(_this.getElement(probableCandidateIndex), true);

      _this.setState({
        queryString: '',
        highlightCountryIndex: probableCandidateIndex
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeydown", function (e) {
      var keys = _this.props.keys;
      var id = e.target.id;
      if (id === 'flag-dropdown' && e.which === keys.ENTER && !_this.state.showDropdown) return _this.handleFlagDropdownClick();
      if (id === 'phone-form-control' && (e.which === keys.ENTER || e.which === keys.ESC)) return e.target.blur();
      if (!_this.state.showDropdown || _this.props.disabled) return;

      if (id === 'search-box') {
        if (e.which !== keys.UP && e.which !== keys.DOWN && e.which !== keys.ENTER) {
          if (e.which === keys.ESC && e.target.value === '') {// do nothing // if search field is empty, pass event (close dropdown)
          } else {
              return; // don't process other events coming from the search field
            }
        }
      } // ie hack


      if (e.preventDefault) {
        e.preventDefault();
      } else {
        e.returnValue = false;
      }

      var moveHighlight = function moveHighlight(direction) {
        _this.setState({
          highlightCountryIndex: _this.getHighlightCountryIndex(direction)
        }, function () {
          _this.scrollTo(_this.getElement(_this.state.highlightCountryIndex + _this.state.preferredCountries.length), true);
        });
      };

      switch (e.which) {
        case keys.DOWN:
          moveHighlight(1);
          break;

        case keys.UP:
          moveHighlight(-1);
          break;

        case keys.ENTER:
          if (_this.props.enableSearchField) {
            _this.handleFlagItemClick(_this.getSearchFilteredCountries()[_this.state.highlightCountryIndex], e);
          } else {
            _this.handleFlagItemClick(_this.state.onlyCountries[_this.state.highlightCountryIndex], e);
          }

          break;

        case keys.ESC:
          _this.setState({
            showDropdown: false
          }, _this.cursorToEnd);

          break;

        default:
          if (e.which >= keys.A && e.which <= keys.Z || e.which === keys.SPACE) {
            _this.setState({
              queryString: _this.state.queryString + String.fromCharCode(e.which)
            }, _this.state.debouncedQueryStingSearcher);
          }

      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputKeyDown", function (e) {
      var keys = _this.props.keys;

      if (e.which === keys.ENTER) {
        _this.props.onEnterKeyPress(e);
      }

      if (_this.props.onKeyDown) _this.props.onKeyDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      if (_this.dropdownRef && !_this.dropdownContainerRef.contains(e.target)) {
        _this.state.showDropdown && _this.setState({
          showDropdown: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearchChange", function (e) {
      var searchValue = e.currentTarget.value;

      _this.setState({
        searchValue: searchValue
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDropdownCountryName", function (country) {
      return country.localName || country.name;
    });

    _defineProperty(_assertThisInitialized(_this), "getSearchFilteredCountries", function () {
      var _this$state = _this.state,
          preferredCountries = _this$state.preferredCountries,
          onlyCountries = _this$state.onlyCountries,
          searchValue = _this$state.searchValue;
      var enableSearchField = _this.props.enableSearchField;
      var allCountries = preferredCountries.concat(onlyCountries);
      var sanitizedSearchValue = searchValue.trim().toLowerCase();
      var searchedCountries = enableSearchField && sanitizedSearchValue ? // using [...new Set()] here to get rid of duplicates
      _toConsumableArray(new Set(allCountries.filter(function (_ref) {
        var name = _ref.name,
            localName = _ref.localName,
            iso2 = _ref.iso2,
            dialCode = _ref.dialCode;
        return ["".concat(name), "".concat(localName), "".concat(iso2), "+".concat(dialCode)].some(function (field) {
          return field.toLowerCase().includes(sanitizedSearchValue);
        });
      }))) : allCountries;
      if (_this.props.disableAreaCodes) searchedCountries = _this.deleteAreaCodes(searchedCountries);
      return searchedCountries;
    });

    _defineProperty(_assertThisInitialized(_this), "getCountryDropdownList", function () {
      var _classNames;

      var _this$state2 = _this.state,
          preferredCountries = _this$state2.preferredCountries,
          highlightCountryIndex = _this$state2.highlightCountryIndex,
          showDropdown = _this$state2.showDropdown,
          searchValue = _this$state2.searchValue;
      var _this$props3 = _this.props,
          enableSearchField = _this$props3.enableSearchField,
          disableSearchIcon = _this$props3.disableSearchIcon,
          searchClass = _this$props3.searchClass,
          searchStyle = _this$props3.searchStyle,
          searchPlaceholder = _this$props3.searchPlaceholder;

      var countryIsPreferred = _this.state.preferredCountries.includes(_this.state.selectedCountry);

      var searchedCountries = _this.getSearchFilteredCountries();

      var countryDropdownList = searchedCountries.map(function (country, index) {
        var itemClasses = (0, _classnames["default"])({
          country: true,
          preferred: country.iso2 === 'us' || country.iso2 === 'gb',
          active: country.iso2 === 'us',
          highlight: countryIsPreferred ? highlightCountryIndex === index : highlightCountryIndex === index - preferredCountries.length
        });
        var inputFlagClasses = "flag ".concat(country.iso2);
        return /*#__PURE__*/_react["default"].createElement("li", {
          ref: function ref(el) {
            return _this["flag_no_".concat(index)] = el;
          },
          key: "flag_no_".concat(index),
          "data-flag-key": "flag_no_".concat(index),
          className: itemClasses,
          "data-dial-code": "1",
          tabIndex: "0",
          "data-country-code": country.iso2,
          onClick: function onClick() {
            return _this.handleFlagItemClick(country);
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: inputFlagClasses
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: "country-name"
        }, _this.getDropdownCountryName(country)), /*#__PURE__*/_react["default"].createElement("span", {
          className: "dial-code"
        }, '+' + country.dialCode));
      });

      var dashedLi = /*#__PURE__*/_react["default"].createElement("li", {
        key: 'dashes',
        className: "divider"
      }); // let's insert a dashed line in between preffered countries and the rest


      preferredCountries.length > 0 && countryDropdownList.splice(preferredCountries.length, 0, dashedLi);
      var dropDownClasses = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, _this.props.dropdownClass, true), _defineProperty(_classNames, 'country-list', true), _defineProperty(_classNames, "hide", !showDropdown), _classNames));
      return /*#__PURE__*/_react["default"].createElement("ul", {
        ref: function ref(el) {
          return _this.dropdownRef = el;
        },
        className: dropDownClasses,
        style: _this.props.dropdownStyle
      }, enableSearchField && /*#__PURE__*/_react["default"].createElement("li", {
        className: (0, _classnames["default"])(_defineProperty({
          search: true
        }, searchClass, searchClass))
      }, !disableSearchIcon && /*#__PURE__*/_react["default"].createElement("span", {
        className: (0, _classnames["default"])(_defineProperty({
          'search-emoji': true
        }, "".concat(searchClass, "-emoji"), searchClass)),
        role: "img",
        "aria-label": "Magnifying glass"
      }, "\uD83D\uDD0E"), /*#__PURE__*/_react["default"].createElement("input", {
        className: (0, _classnames["default"])(_defineProperty({
          'search-box': true
        }, "".concat(searchClass, "-box"), searchClass)),
        style: searchStyle,
        id: "search-box",
        type: "search",
        placeholder: searchPlaceholder,
        autoFocus: true,
        value: searchValue,
        onChange: _this.handleSearchChange
      })), countryDropdownList.length > 0 ? countryDropdownList : /*#__PURE__*/_react["default"].createElement("li", {
        className: "no-entries-message"
      }, /*#__PURE__*/_react["default"].createElement("span", null, "No entries to show.")));
    });

    var _filteredCountries = _country_data["default"].allCountries;
    if (props.regions) _filteredCountries = _this.filterRegions(props.regions, _filteredCountries);

    var _onlyCountries = _this.excludeCountries(_this.getFilteredCountryList(props.onlyCountries, _filteredCountries, props.preserveOrder.includes('onlyCountries')), props.excludeCountries);

    var _preferredCountries = props.preferredCountries.length === 0 ? [] : _this.getFilteredCountryList(props.preferredCountries, _filteredCountries, props.preserveOrder.includes('preferredCountries'));

    var _inputNumber = props.value.replace(/[^0-9\.]+/g, '') || '';

    var countryGuess;

    if (_inputNumber.length > 1) {
      // Country detect by value field
      countryGuess = _this.guessSelectedCountry(_inputNumber.substring(0, 6), _onlyCountries, props.defaultCountry) || 0;
    } else if (props.defaultCountry) {
      // Default country
      countryGuess = _onlyCountries.find(function (o) {
        return o.iso2 == props.defaultCountry;
      }) || 0;
    } else {
      // Empty params
      countryGuess = 0;
    }

    var _dialCode = _inputNumber.length < 2 && countryGuess && !(0, _lodash4["default"])(_inputNumber.replace(/\D/g, ''), countryGuess.dialCode) ? countryGuess.dialCode : '';

    var _formattedNumber;

    _formattedNumber = _inputNumber === '' && countryGuess === 0 ? '' : _this.formatNumber((props.disableCountryCode ? '' : _dialCode) + _inputNumber.replace(/\D/g, ''), countryGuess.name ? countryGuess.format : undefined);

    var _highlightCountryIndex = _filteredCountries.findIndex(function (o) {
      return o == countryGuess;
    });

    _this.state = {
      formattedNumber: _formattedNumber,
      onlyCountries: _onlyCountries,
      preferredCountries: _preferredCountries,
      defaultCountry: props.defaultCountry,
      selectedCountry: countryGuess,
      highlightCountryIndex: _highlightCountryIndex,
      queryString: '',
      showDropdown: false,
      freezeSelection: false,
      debouncedQueryStingSearcher: (0, _lodash["default"])(_this.searchCountry, 250),
      searchValue: ''
    };
    return _this;
  }

  _createClass(PhoneInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document.addEventListener) {
        document.addEventListener('mousedown', this.handleClickOutside);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (document.removeEventListener) {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.defaultCountry && nextProps.defaultCountry !== this.state.defaultCountry) {
        this.updateDefaultCountry(nextProps.defaultCountry);
      } else if (nextProps.value !== this.state.formattedNumber) {
        this.updateFormattedNumber(nextProps.value);
      }
    } // Countries array methods

  }, {
    key: "updateFormattedNumber",
    value: function updateFormattedNumber(value) {
      var _this$state3 = this.state,
          onlyCountries = _this$state3.onlyCountries,
          defaultCountry = _this$state3.defaultCountry;
      var newSelectedCountry;
      var inputNumber = value;
      var formattedNumber = value; // if inputNumber does not start with '+', then use default country's dialing prefix,
      // otherwise use logic for finding country based on country prefix.

      if (!(0, _lodash4["default"])(inputNumber, '+')) {
        newSelectedCountry = this.state.selectedCountry || onlyCountries.find(function (o) {
          return o.iso2 == defaultCountry;
        });
        var dialCode = newSelectedCountry && !(0, _lodash4["default"])(inputNumber.replace(/\D/g, ''), newSelectedCountry.dialCode) ? newSelectedCountry.dialCode : '';
        formattedNumber = this.formatNumber((this.props.disableCountryCode ? '' : dialCode) + inputNumber.replace(/\D/g, ''), newSelectedCountry ? newSelectedCountry.format : undefined);
      } else {
        inputNumber = inputNumber.replace(/\D/g, '');
        newSelectedCountry = this.guessSelectedCountry(inputNumber.substring(0, 6), onlyCountries, defaultCountry);
        formattedNumber = this.formatNumber(inputNumber, newSelectedCountry.format);
      }

      this.setState({
        selectedCountry: newSelectedCountry,
        formattedNumber: formattedNumber
      });
    } // View methods

  }, {
    key: "render",
    value: function render() {
      var _classNames5,
          _classNames6,
          _this2 = this;

      var _this$state4 = this.state,
          selectedCountry = _this$state4.selectedCountry,
          showDropdown = _this$state4.showDropdown,
          formattedNumber = _this$state4.formattedNumber;
      var _this$props4 = this.props,
          disableDropdown = _this$props4.disableDropdown,
          renderStringAsFlag = _this$props4.renderStringAsFlag;
      var arrowClasses = (0, _classnames["default"])({
        arrow: true,
        up: showDropdown
      });
      var inputClasses = (0, _classnames["default"])((_classNames5 = {}, _defineProperty(_classNames5, this.props.inputClass, true), _defineProperty(_classNames5, 'form-control', true), _defineProperty(_classNames5, 'invalid-number', !this.props.isValid(formattedNumber.replace(/\D/g, ''))), _classNames5));
      var flagViewClasses = (0, _classnames["default"])((_classNames6 = {}, _defineProperty(_classNames6, this.props.buttonClass, true), _defineProperty(_classNames6, 'flag-dropdown', true), _defineProperty(_classNames6, 'open-dropdown', showDropdown), _classNames6));
      var inputFlagClasses = "flag ".concat(selectedCountry && selectedCountry.iso2);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.containerClass,
        style: this.props.containerStyle,
        onKeyDown: this.handleKeydown
      }, /*#__PURE__*/_react["default"].createElement("input", _extends({
        className: inputClasses,
        id: "phone-form-control",
        style: this.props.inputStyle,
        onChange: this.handleInput,
        onClick: this.handleInputClick,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        value: formattedNumber,
        ref: function ref(el) {
          return _this2.numberInputRef = el;
        },
        onKeyDown: this.handleInputKeyDown,
        placeholder: this.props.placeholder,
        disabled: this.props.disabled,
        type: "tel"
      }, this.props.inputExtraProps)), /*#__PURE__*/_react["default"].createElement("div", {
        className: flagViewClasses,
        id: "flag-dropdown",
        style: this.props.buttonStyle,
        ref: function ref(el) {
          return _this2.dropdownContainerRef = el;
        },
        tabIndex: "0",
        role: "button"
      }, renderStringAsFlag ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "selected-flag"
      }, renderStringAsFlag) : /*#__PURE__*/_react["default"].createElement("div", {
        onClick: disableDropdown ? undefined : this.handleFlagDropdownClick,
        className: "selected-flag",
        title: selectedCountry ? "".concat(selectedCountry.name, ": + ").concat(selectedCountry.dialCode) : ''
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: inputFlagClasses
      }, !disableDropdown && /*#__PURE__*/_react["default"].createElement("div", {
        className: arrowClasses
      }))), showDropdown && this.getCountryDropdownList()));
    }
  }]);

  return PhoneInput;
}(_react["default"].Component);

_defineProperty(PhoneInput, "propTypes", {
  excludeCountries: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onlyCountries: _propTypes["default"].arrayOf(_propTypes["default"].string),
  preferredCountries: _propTypes["default"].arrayOf(_propTypes["default"].string),
  defaultCountry: _propTypes["default"].string,
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  searchPlaceholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  containerStyle: _propTypes["default"].object,
  inputStyle: _propTypes["default"].object,
  buttonStyle: _propTypes["default"].object,
  dropdownStyle: _propTypes["default"].object,
  searchStyle: _propTypes["default"].object,
  containerClass: _propTypes["default"].string,
  inputClass: _propTypes["default"].string,
  buttonClass: _propTypes["default"].string,
  dropdownClass: _propTypes["default"].string,
  searchClass: _propTypes["default"].string,
  autoFormat: _propTypes["default"].bool,
  disableAreaCodes: _propTypes["default"].bool,
  disableCountryCode: _propTypes["default"].bool,
  disableDropdown: _propTypes["default"].bool,
  enableLongNumbers: _propTypes["default"].bool,
  countryCodeEditable: _propTypes["default"].bool,
  enableSearchField: _propTypes["default"].bool,
  disableSearchIcon: _propTypes["default"].bool,
  regions: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  inputExtraProps: _propTypes["default"].object,
  localization: _propTypes["default"].object,
  masks: _propTypes["default"].object,
  areaCodes: _propTypes["default"].object,
  preserveOrder: _propTypes["default"].arrayOf(_propTypes["default"].string),
  renderStringAsFlag: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  isValid: _propTypes["default"].func
});

_defineProperty(PhoneInput, "defaultProps", {
  excludeCountries: [],
  onlyCountries: [],
  preferredCountries: [],
  defaultCountry: '',
  value: '',
  placeholder: '+1 (702) 123-4567',
  searchPlaceholder: 'search',
  flagsImagePath: './flags.png',
  disabled: false,
  containerStyle: {},
  inputStyle: {},
  buttonStyle: {},
  dropdownStyle: {},
  searchStyle: {},
  containerClass: 'react-tel-input',
  inputClass: '',
  buttonClass: '',
  dropdownClass: '',
  searchClass: '',
  autoFormat: true,
  disableAreaCodes: false,
  isValid: function isValid(inputNumber) {
    return _country_data["default"].allCountries.some(function (country) {
      return (0, _lodash4["default"])(inputNumber, country.dialCode) || (0, _lodash4["default"])(country.dialCode, inputNumber);
    });
  },
  disableCountryCode: false,
  disableDropdown: false,
  enableLongNumbers: false,
  countryCodeEditable: true,
  enableSearchField: false,
  disableSearchIcon: false,
  regions: '',
  inputExtraProps: {},
  localization: {},
  masks: {},
  areaCodes: {},
  preserveOrder: [],
  renderStringAsFlag: '',
  onEnterKeyPress: function onEnterKeyPress() {},
  keys: {
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    LEFT: 37,
    ENTER: 13,
    ESC: 27,
    PLUS: 43,
    A: 65,
    Z: 90,
    SPACE: 32
  }
});

var _default = PhoneInput;
exports["default"] = _default;